module.exports = __webpack_public_path__ + "media/images/bubble-img-service-intro-question-02-ee3859839779aa22d9bb61a0272b287f.png";